import { useState } from 'react';
import CookieConsent, { Cookies, getCookieConsentValue } from "react-cookie-consent";
import {
    MDBBtn,
    MDBSwitch,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-react-ui-kit';

window.dataLayer = window.dataLayer || [];

const BmiCookieConsent = (props) => {
    const [cookiesModal, showCookiesModal] = useState(false);
    const [ccVisibility, setCcVisibility] = useState(true);
    const [performanceCookie, setPerformanceCookie] = useState(false);
    const [targetingCookie, setTargetingCookie] = useState(false);
    const bmiczCookie = getCookieConsentValue("BmiczCookieConsent");

    if (bmiczCookie != undefined) {
        var cookieValue = bmiczCookie.substring(7);
        var cookies = cookieValue.split(',');
        var perfCookie = cookies[1].slice(-1);
        if (perfCookie == 1) {
            gtag('consent', 'update', {
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'analytics_storage': 'granted'
            });
        }
    }

    function gtag() { window.dataLayer.push(arguments); }

    function consentAll() {
        gtag('consent', 'update', {
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'analytics_storage': 'granted'
        });
        var cookieValue = "groups=C0001:1,C0007:1,C0004:1"
        setCookie("BmiczCookieConsent", cookieValue, 365);
        setCcVisibility(false);
    }

    function denyAll() {
        gtag('consent', 'update', {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'analytics_storage': 'denied'
        });
        var cookieValue = "groups=C0001:1,C0007:0,C0004:0"
        setCookie("BmiczCookieConsent", cookieValue, 365);
        setCcVisibility(false);
    }

    function acceptSelected() {
        var cookieValue = "groups=C0001:1";
        if (performanceCookie) {
            cookieValue += ",C0007:1";
            gtag('consent', 'update', {
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'analytics_storage': 'granted'
            });
        } else {
            cookieValue += ",C0007:0";
        }
        if (targetingCookie) {
            cookieValue += ",C0004:1";
        } else {
            cookieValue += ",C0004:0";
        }
        setCookie("BmiczCookieConsent", cookieValue, 365);
    }

    const cookiesModalBody = () => {
        return (
            <div className="">
                <h2 className="nadpis">Centrum pre ochranu osobných údajov pred voľbami</h2>
                <div className="mb-3">
                    <p className="text-secondary mb-0">
                        Pri návšteve akejkoľvek webovej stránky je pravdepodobné, že stránka získa alebo uloží informácie vo vašom prehliadači, a to väčšinou vo forme súborov cookie.
                        Môžu to byť informácie týkajúce sa vás, vašich preferencií a zariadenia, ktoré používate. Väčšinou slúžia na vylepšovanie stránky, aby fungovala podľa vašich očakávaní.
                        Informácie vás spravidla neidentifikujú ako jednotlivca, ale celkovo môžu pomôcť prispôsobiť prostredie vašim potrebám.
                        Rešpektujeme vaše právo na súkromie, a preto sa môžete rozhodnúť, že niektoré súbory cookie neprijmete.
                        Kliknutím na jednotlivé položky sa dozviete viac a budete môcť zmeniť nastavenia. Nezabudnite však, že blokovaním niektorých súborov cookie môžete ovplyvniť,
                        ako stránka funguje a aké služby vám ponúka.
                    </p>
                    <a className="content-link" href="https://www.bmigroup.com/cz/cookies/" target="_blank">cookie-policy</a>
                </div>
                <button className="btn btn-primary" onClick={() => {
                    showCookiesModal(false);
                    consentAll();
                }}>
                    Povoliť všetko
                </button>
                <section className="mt-5">
                    <h3 className="nadpis">Správa predvolieb udeľovania súhlasu</h3>
                    <div className="pb-4">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="fw-bold m-0 mx-2">Absolútne nevyhnutné súbory cookie</h4>
                            <div className="c-primary fw-bold fs-4">Vždy aktívny</div>
                        </div>
                        <div>
                            <p className="text-secondary mx-0 my-2 pe-5">
                                Sú nevyhnutné na fungovanie webovej stránky, preto ich nie je možné vypnúť. Väčšinou sú nastavené ako reakcia na akcie, ktoré ste vykonali,
                                ako napríklad požiadavky na služby týkajúce sa bezpečnostných nastavení, prihlásenia, vyplňovania formulárov atď. Prehliadač môžete nastaviť tak,
                                aby blokoval súbory cookie alebo o nich zasielal upozornenia. Majte na pamäti, že niektoré stránky bez týchto súborov nebudú fungovať.
                                Tieto súbory cookie neukladajú žiadne osobné identifikovateľné informácie.
                            </p>
                        </div>
                    </div>
                    <div className="pb-4">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="fw-bold m-0 mx-2">Súbory cookie na zvýšenie výkonu</h4>
                            <div className="form-check form-switch">
                                <MDBSwitch defaultChecked={performanceCookie}
                                    onClick={(e) => setPerformanceCookie(e.target.checked)} />
                            </div>
                        </div>
                        <div>
                            <p className="text-secondary mx-0 my-2 pe-5">
                                Pomáhajú sledovať počet návštevníkov a tiež zdroj, z ktorého prichádza návštevnosť, čo nám umožňuje zlepšovať výkonnosť stránky.
                                Pomocou nich môžeme zistiť, ktoré stránky sú najobľúbenejšie a ktoré nie sú, a tiež sledovať, ako sa návštevníci na webe pohybujú.
                                Všetky informácie, ktoré súbory cookie zhromažďujú, sú súhrnné a anonymné. Ak súbory cookie nepovolíte, nebudeme vedieť, kedy ste navštívili našu stránku.
                            </p>
                        </div>
                    </div>
                    <div className="pb-4">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="fw-bold m-0 mx-2">Cielené súbory cookie</h4>
                            <div className="form-check form-switch">
                                <MDBSwitch defaultChecked={targetingCookie}
                                    onClick={(e) => setTargetingCookie(e.target.checked)} />
                            </div>
                        </div>
                        <div>
                            <p className="text-secondary mx-0 my-2 pe-5">
                                Pomáhajú sledovať počet návštevníkov a tiež zdroj, z ktorého prichádza návštevnosť, čo nám umožňuje zlepšovať výkonnosť stránky.
                                Pomocou nich môžeme zistiť, ktoré stránky sú najobľúbenejšie a ktoré nie sú, a tiež sledovať, ako sa návštevníci na webe pohybujú.
                                Všetky informácie, ktoré súbory cookie zhromažďujú, sú súhrnné a anonymné. Ak súbory cookie nepovolíte, nebudeme vedieť, kedy ste navštívili našu stránku.
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    const ccbuttons = () => {
        return (
            <div className=''>
                <button className='btn btn-outline col-md-auto col-12' onClick={() => showCookiesModal(true)}>Nastavenia súborov cookie</button>
                <button className='btn btn-outline col-md-auto col-12' onClick={() => denyAll()}>Zrušiť všetko</button>
                <button className='btn btn-primary col-md-auto col-12' onClick={() => consentAll()}>Prijmúť všetky súbory cookie</button>
            </div>
        );
    }

    //console.log("cc", window.dataLayer[0][2]);
    return (bmiczCookie == undefined) ? (
        <span>
            <CookieConsent
                location="bottom"
                visible={ccVisibility}
                cookieName="BmiczCookieConsent"
                buttonText="Přijmout všechny soubory cookie"
                onAccept={() => consentAll()}
                disableStyles={true}
                containerClasses="cookie-consent-banner p-3"
                contentClasses="col-lg-6 col-12 align-items-center d-flex"
                buttonWrapperClasses="col-lg-6 col-12"
                ButtonComponent={ccbuttons}
            >
                <p className="small">
                    Ak kliknete na „Prijmúť všetky súbory cookie“, vyjadríte tým súhlas s ich ukladaním do vášho zariadenia,
                    čo pomáha pri navigácii na stránke, pri analýze využívania údajov a pri našich marketingových aktivitách.&nbsp;
                    <a href="https://www.bmigroup.com/cz/cookies/" className="content-link">cookie-policy</a>
                </p>
            </CookieConsent>
            <MDBModal open={cookiesModal} tabIndex='-1' onClose={() => showCookiesModal(false)}>
                <MDBModalDialog scrollable size='lg'>
                    <MDBModalContent className='p-2'>
                        <MDBModalHeader>
                            <MDBModalTitle className='text-uppercase'>Nastavenia súborov cookie</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={() => showCookiesModal(false)}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            {cookiesModalBody()}
                        </MDBModalBody>
                        <MDBModalFooter>
                            <button className='btn btn-secondary' onClick={() => {
                                showCookiesModal(false);
                                denyAll();
                            }}>
                                Zrušiť všetko
                            </button>
                            <button className=' btn btn-primary' onClick={() => {
                                showCookiesModal(false);
                                acceptSelected();
                            }}>
                                Potvrdiť moje voľby
                            </button>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </span>
    ) : (<span></span>);

}

export default BmiCookieConsent;


function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;SameSite=None; Secure";
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}